<template>
  <div>
    <h4 class="font-bold text-lg mb-4">
      Field Mapping
    </h4>
    <base-notice v-if="!target">
      Select an export Target first
    </base-notice>
    <base-notice v-else-if="fields.length === 0">
      Selected Target's Saint Header is not specified
    </base-notice>
    <div
      v-else
      v-for="field in fields"
      :key="field.name"
      class="flex items-center mb-1"
    >
      <p class="w-40">{{ field.name }}</p>
      <select v-model="field.mapping.operation" class="px-4 py-2 mr-4">
        <option
          v-for="operation in operations"
          :key="operation.value"
          :value="operation.value"
        >
          {{ operation.label }}
        </option>
      </select>
      <template v-if="field.mapping.operation === 'default'">
        <input
          type="text"
          v-model="field.mapping.default_value"
          class="px-4 py-2"
        />
      </template>
      <template v-if="field.mapping.operation === 'map'">
        <span class="mr-4">to</span>
        <select v-model="field.mapping.target1" class="px-4 py-2">
          <option
            v-for="internalField in internalFields"
            :key="internalField.value"
            :value="internalField.value"
            >{{ internalField.label }}</option
          >
        </select>
      </template>
      <template v-if="field.mapping.operation === 'concat'">
        <select v-model="field.mapping.target1" class="px-4 py-2 mr-3">
          <option
            v-for="internalField in internalFields"
            :key="internalField.value"
            :value="internalField.value"
            >{{ internalField.label }}</option
          >
        </select>
        <span class="mr-3">+</span>
        <input
          type="text"
          v-model="field.mapping.default_value"
          class="w-12 px-4 py-2 mr-3 text-center"
        />
        <span class="mr-3">+</span>
        <select v-model="field.mapping.target2" class="px-4 py-2 mr-4">
          <option
            v-for="internalField in internalFields"
            :key="internalField.value"
            :value="internalField.value"
            >{{ internalField.label }}</option
          >
        </select>
      </template>
      <template v-if="field.mapping.operation === 'extract'">
        <span class="mr-3">from</span>
        <select v-model="field.mapping.target1" class="px-4 py-2 mr-3">
          <option
            v-for="internalField in internalFields"
            :key="internalField.value"
            :value="internalField.value"
            >{{ internalField.label }}</option
          >
        </select>
        <span class="mr-3">split by</span>
        <input
          type="text"
          :name="`${field.name}-separator`"
          v-model="field.mapping.separator"
          class="w-12 px-4 py-2 mr-3 text-center"
        />
        <span class="mr-3">and take index</span>
        <input
          type="number"
          min="0"
          :name="`${field.name}-index`"
          v-model="field.mapping.index"
          class="w-16 px-4 py-2 mr-3 text-center"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mappingToForm } from '../services/mappingToForm';
import { mappingToFormEmpty } from '../services/mappingToFormEmpty';

export default {
  props: {
    target: Object,
  },
  data() {
    return {
      fields: [],
      operations: [
        {
          label: 'Default',
          value: 'default',
        },
        {
          label: 'Map',
          value: 'map',
        },
        {
          label: 'Concatenate',
          value: 'concat',
        },
        {
          label: 'Extract',
          value: 'extract',
        },
      ],
    };
  },
  computed: {
    ...mapState({
      currentCompanyId: (state) => state.company.currentId,
      currentSegmentId: (state) => state.company.segment.currentId,
      mappings: (state) => state.company.segment.exports.mappings,
    }),
    internalFields() {
      const company = this.$store.state.company;
      const customFields =
        company.segment.schema.list.length > 0
          ? company.segment.schema.list
          : company.schema.list;
      return [
        {
          label: 'Company name',
          value: 'company.name',
        },
        {
          label: 'Segment name',
          value: 'segment.name',
        },
        {
          label: 'Campaign name',
          value: 'campaign.name',
        },
        {
          label: 'Domain URL',
          value: 'target_url',
        },
        {
          label: 'Tracking parameter',
          value: 'tracking_param',
        },
        {
          label: 'Tracking code ID',
          value: 'tracking_code_id',
        },
        ...customFields.map((item) => ({
          label: item.name,
          value: `client_data.${item.name}`,
        })),
        ...Object.entries(company.parameterNames).flatMap(([value, label]) =>
          value === 'id'
            ? []
            : [
                {
                  label,
                  value: `marketer_data.${value}`,
                },
              ]
        ),
      ];
    },
  },
  watch: {
    fields: {
      deep: true,
      handler(fields) {
        this.$emit('change', fields);
      },
    },
    target() {
      this.setFieldsInitial();
    },
  },
  created() {
    this.setFieldsInitial();
  },
  methods: {
    setFieldsInitial() {
      if (!this.target || !this.target.saint_header) {
        return;
      }
      const mapping = this.mappings.find(
        (m) => m.export_target.id === this.target.id
      );
      this.fields = mapping
        ? mappingToForm(mapping)
        : mappingToFormEmpty(this.target.saint_header);
    },
  },
};
</script>
